import React, { Component } from 'react';
import { Banner } from '../../Components'
import './Contact.scss'
import {Helmet} from "react-helmet"

import { observable } from 'mobx';
import { observer, inject } from 'mobx-react'

@inject('store')
@observer
class componentName extends Component {

	@observable submitted = false

    componentDidMount() {
        window.scrollTo(0,0)
	}
	
	submitForm = e => {
		e.preventDefault()
		this.submitted = true
		let postData = {
			name: e.target.name.value,
			practice: e.target.practice.value,
			email: e.target.email.value,
			phone: e.target.phone.value,
			message: e.target.message.value,
		}
		return this.props.store.api.post('/guest/contact', postData)
			.then(({data}) => {
				console.log(data)
			})
	}

    render() {
        return (
            <div className="about-page">
				<Helmet>
					<title>Contact | GPbook</title>
				</Helmet>	
                <Banner title="Contact Us" subtitle="If want more information about us or to send us a message." />
                
				
				<div className="container m-t-2 m-b-5">
					<p style={{ fontSize: 18 }}>
						GPbook is now an online specialist directory for GPs made locally in Perth. We want to make it easy for GPs to find a specialist to refer their patients to. We offer GPs comprehensive information about specialists so that they can make referrals to the right specialist, saving them time and improving the referral experience for patients.
					</p>	
					<div className="row m-t-2">
						
						<div className="col-md-6">
							
							
							<h2>Send Us a Message</h2>
							<hr/>
							<h3>Email</h3>
							<h4><a href="mailto:info@gpbook.com.au">info@gpbook.com.au</a></h4>
							<hr/>
							{/* <h3>Call</h3>
							<h4>0448 324 286</h4> */}
							{/* <hr /> */}
							{/* <h3>Fax</h3>
							<h4>(08) 6102 1743</h4> */}
							{/* <hr /> */}
							<h3>Find Us</h3>
							<h5>PO Box 29, Mount Lawley WA 6929</h5>

						
							
					</div>
						
					
					<div className="col-md-6">
							<h2>Contact Form</h2>
							<hr/>
							{this.submitted ?
								<div>
								<h3>Thank you for your message. We will take a look at it shortly and get back to you if required.</h3>	
							</div> :
								<form onSubmit={this.submitForm}>
									<h4>Name:</h4>
									<input type="text" className="input" name="name" />
									<h4 className="m-t-1">Practice or Organisation:</h4>
									<input type="text" className="input" name="practice" />
									<h4 className="m-t-1">Phone:</h4>
									<input type="text" className="input" name="phone" />
									<h4 className="m-t-1">Email:</h4>
									<input type="text" className="input" name="email" />
									<h4 className="m-t-1">Message:</h4>
									<textarea name="message" className="input" cols="30" rows="10"  />
									<input type="submit" value="Submit" className="btn lg m-t-1" />
								</form>}
						</div>
					</div>
				</div>

            </div>
        );
    }
}

export default componentName;


// WEBPACK FOOTER //
// ./src/Containers/Contact/Contact.js